import { SOGetRelationshipAttributePermission } from '../relationship-attribute-permission/so-get-relationship-attribute-permission';
import { SOGetRelationshipAttributePermissionRule } from '../relationship-attribute-permission-rule/so-get-relationship-attribute-permission-rule';
import { SOGetEntity } from '../entity/so-get-entity';
import { SOGetCustomLogicRequirement } from '../custom-logic-requirement/so-get-custom-logic-requirement';
import { SOGetRelationship } from '../relationship/so-get-relationship';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENMultiplicity} from '../../enums';


export class SOPutRelationshipAttribute {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public multiplicity: ENMultiplicity = null,
    public editPermissions: boolean = null,
    public relationshipAttributePermissions: SOGetRelationshipAttributePermission[] = null,
    public relationshipAttributePermissionRules: SOGetRelationshipAttributePermissionRule[] = null,
    public entity: SOGetEntity = null,
    public customLogicRequirement: SOGetCustomLogicRequirement = null,
    public relationship: SOGetRelationship = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutRelationshipAttribute(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'multiplicity' in params ? params.multiplicity : null,
      'editPermissions' in params ? params.editPermissions : null,
      'relationshipAttributePermissions' in params ? params.relationshipAttributePermissions : null,
      'relationshipAttributePermissionRules' in params ? params.relationshipAttributePermissionRules : null,
      'entity' in params ? params.entity : null,
      'customLogicRequirement' in params ? params.customLogicRequirement : null,
      'relationship' in params ? params.relationship : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
